import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TermsAndConditions() {
  return (
    <div className="terms-and-conditions-page">
      <header
        className="d-flex align-items-center text-light shadow"
        style={{
          height: "20vh",
          backgroundColor: "#003561",
        }}
      >
        <div className="container">
          <Row className="mt-5">
            <Col sm={12} md={8} lg={6}>
              <h1
                className="text-white fw-bold lh-sm"
                style={{
                  fontSize: "3rem",
                  fontFamily: "Montserrat",
                }}
              >
                Terms & Conditions
              </h1>
            </Col>
          </Row>
        </div>
      </header>
      <br />
      <Container className="my-5">
        <div style={{ fontFamily: "Montserrat", color: "#003561" }}>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Program Name
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Stratus Materials Internal SMS Alerts
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Program Description
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Stratus Materials Inc. operates an
            internal SMS notification service to deliver important company
            communications, operational updates, safety alerts, and
            administrative notifications to employees and team members
            ("Service").
          </p>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            By providing your mobile phone number and consenting to receive
            messages, you agree to these Terms & Conditions.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Message Frequency
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Message frequency varies. You may receive up to
            10 messages per week, depending on company
            communications needs.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Message and Data Rates
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Message and data rates may apply. Stratus Materials
            is not responsible for any charges imposed by your mobile carrier for
            sending or receiving text messages.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Opt-Out / How to Stop
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            You may opt out of receiving SMS notifications at any time by
            replying STOP to any message you receive from us.
            After opting out, you will receive a confirmation message and will no
            longer receive SMS notifications from this Service.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Help / Support
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            For help or support, reply HELP to any message you
            receive from us, or contact us directly:
          </p>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            <strong>Stratus Materials Inc.</strong>
            <br />
            6901 Lynn Way, Suite 320
            <br />
            Pittsburgh, PA 15208
            <br />
            Email:{" "}
            <a href="mailto:info@stratusmaterials.com">
              info@stratusmaterials.com
            </a>
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Supported Carriers
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Our Service is compatible with most major U.S. mobile carriers,
            including AT&T, T-Mobile, Verizon, and others. However, service
            availability may vary by carrier and is not guaranteed.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>Consent</h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            By opting in to receive SMS messages from Stratus Materials, you
            confirm that you are an employee or authorized team member and
            consent to receive text messages at the mobile number provided. Your
            consent is not a condition of employment.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>Privacy</h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            Your privacy is important to us. Please review our{" "}
            <a href="/privacy-policy" style={{ color: "#00ade6" }}>
              Privacy Policy
            </a>{" "}
            for information on how we collect, use, and protect your personal
            data.
          </p>

          <h3 style={{ fontWeight: "700", marginTop: "2rem" }}>
            Changes to These Terms
          </h3>
          <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
            We reserve the right to modify these Terms & Conditions at any time.
            Changes will be communicated to affected employees. Continued
            participation in the Service after changes are made constitutes
            acceptance of the updated terms.
          </p>
        </div>
      </Container>
    </div>
  );
}

export default TermsAndConditions;
